module.exports = __webpack_public_path__ + "img/pacmanmodel (3).e4d7fcf0.jpg";